import type { CSSProperties, PropsWithChildren } from 'react';
import type { PropsWithRefObject } from '../../types';
import type { TooltipProps } from '../Tooltip/types';

const INITIAL_TOOLTIP_CONTAINER_TIMEOUT = 1000;

type TooltipContainerProps = PropsWithChildren &
  Pick<TooltipProps, 'message' | 'placement'> &
  PropsWithRefObject<HTMLElement> & {
    /**
     * 버튼을 클릭한 경우에만 툴팁이 표시됩니다.
     * @default false
     */
    click?: boolean;
    /**
     * 툴팁 컨테이너의 disabled 상태를 설정합니다.
     * @default false
     */
    disabled?: boolean;
    /**
     * 툴팁 컨테이너의 디스플레이 속성을 설정합니다.
     * @default 'inline-block'
     */
    display?: CSSProperties['display'];
    /**
     * click = true일 때, 툴팁이 표시되는 시간입니다.
     * @default 1000
     */
    timeout?: number;
    /**
     * message, placement를 제외한 tooltip의 props를 설정 할 수 있습니다.
     */
    tooltipProps?: Omit<TooltipProps, 'children' | 'message' | 'placement'>;
    /**
     * 툴팁 컨테이너의 너비를 설정합니다.
     * @default 'fit-content'
     */
    width?: CSSProperties['width'];
  };

export { INITIAL_TOOLTIP_CONTAINER_TIMEOUT };
export type { TooltipContainerProps };
